import { Injectable, Injector } from '@angular/core';
// import { HttpPaginationDataProxy } from '@jeanologia/ng-interfaces';
// import { Observable } from 'rxjs';
// import { filter, map, tap } from 'rxjs/operators';
// import { ProductsDataSource } from './apps.datasource';
// import { CompaniesDataSource } from './companies.datasource';

@Injectable()
export class CouponsDataProxy {} {
// export class CouponsDataProxy extends HttpPaginationDataProxy {
//   constructor(
//     injector: Injector,
//     private companiesDataSource: CompaniesDataSource,
//     private productsDatSource: ProductsDataSource,
//   ) {
//     super(injector);
//   }

//   init(config: any) {
//     if (typeof config.service === 'string') {
//       this.service = this.injector.get(config.service);
//     } else {
//       this.service = config.service;
//     }
//     const obs = this.service.init(config.url) as Observable<any>;

//     return this.transform$(obs);
//   }

//   transform$(obs: Observable<any>): Observable<any> {
//     return obs.pipe(
//       filter((data) => data !== null && data !== undefined),
//       map((data) => this.transform(data)),
//       tap((data) => {
//         const app_ids = data.map((value) => value.app_id);
//         const company_ids = data.map((value) => value.company_id);
//         this.companiesDataSource.setBulk(company_ids);
//         this.productsDatSource.setBulk(app_ids);
//       }),
//     );
//   }
}
